import { createReducer, on } from '@ngrx/store';
import {
  clearNewOrderSelectByKey,
  loadNewOrderSelect,
  loadNewOrderSelectFailure,
  loadNewOrderSelectSuccess,
} from './new-order-select.actions';

export interface NewOrderSelectState {
  cache: { [key: string]: any[] };
  loading: { [key: string]: boolean };
  error: { [key: string]: string | null };
}

export const initialState: NewOrderSelectState = {
  cache: {},
  loading: {},
  error: {},
};

export const newOrderSelectReducer = createReducer(
  initialState,
  on(loadNewOrderSelect, (state, { key }) => ({
    ...state,
    loading: { ...state.loading, [key]: true },
    error: { ...state.error, [key]: null },
  })),
  on(loadNewOrderSelectSuccess, (state, { key, data }) => ({
    ...state,
    cache: { ...state.cache, [key]: data ?? [] },
    loading: { ...state.loading, [key]: false },
    error: { ...state.error, [key]: null },
  })),
  on(loadNewOrderSelectFailure, (state, { key, error }) => ({
    ...state,
    loading: { ...state.loading, [key]: false },
    error: { ...state.error, [key]: error },
  })),
  on(clearNewOrderSelectByKey, (state, { key }) => {
    const { [key]: _, ...restCache } = state.cache;
    const { [key]: __, ...restLoading } = state.loading;
    const { [key]: ___, ...restError } = state.error;
    return {
      ...state,
      cache: restCache,
      loading: restLoading,
      error: restError,
    };
  }),
);
